import React from "react";
import { motion } from "framer-motion";
import { process } from "../../mock/mock";

export default function Process() {
  return (
    <section id="process" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div>
            <div className="section-label mb-6">Work Process</div>
            <h2 className="font-display text-[42px] md:text-[64px] leading-[1.02] tracking-[-0.02em] max-w-3xl">
              A step-by-step <span className="italic sage-text">process</span> behind every great project.
            </h2>
          </div>
          <p className="max-w-sm text-[15px] leading-[1.7] text-[var(--text-dim)]">
            A structured approach to ensure every project is delivered with creativity, strategy, and measurable outcomes.
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-0 right-0 top-[58px] h-px bg-white/5 hidden lg:block" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
            {process.map((p, i) => (
              <motion.div key={p.num}
                initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.55, delay: i * 0.08 }}
                className="relative">
                <div className="relative h-12 w-12 rounded-full border border-white/10 bg-[var(--bg)] inline-flex items-center justify-center">
                  <span className="mono text-[12px] tracking-[0.1em] text-[var(--sage)]">{p.num}</span>
                </div>
                <h3 className="mt-6 font-display text-[22px] leading-tight">{p.title}</h3>
                <p className="mt-3 text-[14px] leading-[1.7] text-[var(--text-dim)]">{p.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
